"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedList = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var luxon_1 = require("luxon");
var withPagination_1 = __importStar(require("../hocs/withPagination"));
var session_1 = require("../util/session");
var grid_1 = require("./grid");
var routes_1 = require("../util/routes");
var PaginationControls_1 = require("./PaginationControls");
var SCROLL_LIST_POSITION = 'SCROLL_LIST_POSITION';
exports.PaginatedList = (0, withPagination_1.default)(function (_a) {
    var children = _a.children;
    var _b = (0, withPagination_1.usePaginationContext)(), metadata = _b.metadata, scrollOffset = _b.scrollOffset, loading = _b.loading;
    var query = (0, routes_1.useQuery)();
    var queryStr = query.toString();
    var ref = (0, react_2.useRef)();
    var initialized = (0, react_2.useRef)();
    var isScrolled = (0, react_2.useRef)(false);
    var scrollValue = (0, react_2.useRef)(typeof window !== 'undefined' ? window.scrollY : 0);
    (0, react_2.useEffect)(function () {
        if (isScrolled.current || loading) {
            return;
        }
        try {
            var data = JSON.parse((0, session_1.getSessionKey)(SCROLL_LIST_POSITION) || '{}');
            if (data.uri && data.uri === queryStr) {
                var scrollY_1 = parseInt(data.scrollY, 10);
                scrollY_1 && window.scrollTo({ top: scrollY_1 });
            }
        }
        finally {
            isScrolled.current = true;
            (0, session_1.clearSessionKey)(SCROLL_LIST_POSITION);
        }
    }, [loading, queryStr]);
    (0, react_2.useLayoutEffect)(function () {
        var savePositionHandler = function () {
            scrollValue.current = window.scrollY;
        };
        window.addEventListener('scroll', savePositionHandler, false);
        return function () {
            window.removeEventListener('scroll', savePositionHandler, false);
            (0, session_1.setSessionKey)({
                name: SCROLL_LIST_POSITION,
                value: JSON.stringify({
                    uri: queryStr,
                    scrollY: scrollValue.current,
                }),
                expireAt: luxon_1.DateTime.now().plus(luxon_1.Duration.fromObject({ hour: 1 })),
            });
        };
    }, [queryStr]);
    (0, react_2.useEffect)(function () {
        var _a, _b, _c, _d, _e;
        if (initialized.current) {
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.top;
            var y = ((_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) === null || _d === void 0 ? void 0 : _d.top) !== null && _e !== void 0 ? _e : 0) +
                window.pageYOffset +
                scrollOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
        else {
            initialized.current = true;
        }
    }, [metadata.page, scrollOffset, initialized]);
    var showPagination = (metadata.total_count || 0) > (metadata.per_page || 0);
    return (react_1.default.createElement(grid_1.Container, { ref: ref },
        react_1.default.createElement(grid_1.Item, { cols: 12 }, children),
        showPagination && (react_1.default.createElement(grid_1.Item, { pt: 3, cols: 12 },
            react_1.default.createElement(PaginationControls_1.PaginationControls, null)))));
});
//# sourceMappingURL=PaginatedList.js.map